import { CardNumbersApiModel, CardShapeApiModel, CardStyleApiModel } from '@cxb/editor-stb-api';

export enum TraySelectorType {
  LandscapeSmall = 'LandscapeSmall',
  LandscapeLarge = 'LandscapeLarge',
  PortraitSmall = 'PortraitSmall',
  PortraitLarge = 'PortraitLarge',
  CollectionPortrait = 'CollectionPortrait',
  CollectionLandscape = 'CollectionLandscape',
  Top10 = 'Top10',
  Branded = 'Branded',
  Genre = 'Genre',
  Kids = 'Kids',
  MarketingCTATwoCard = 'MarketingCTATwoCard',
  MarketingCTAThreeCard = 'MarketingCTAThreeCard',
  MarketingCTAFourCard = 'MarketingCTAFourCard',
  MarketingCTALeft = 'MarketingCTALeft',
  MarketingCTARight = 'MarketingCTARight',
  MarketingTrendingLeft = 'MarketingTrendingLeft',
  MarketingTrendingRight = 'MarketingTrendingRight',
  MarketingEmailCollectorCentered = 'MarketingEmailCollectorCentered',
  MarketingEmailCollectorLeft = 'MarketingEmailCollectorLeft',
  MarketingEmailCollectorRight = 'MarketingEmailCollectorRight',
  MarketingMultipleContentPortrait = 'MarketingMultipleContentPortrait',
  MarketingMultipleContentLandscape = 'MarketingMultipleContentLandscape',
  DetailedPageBannerLeft = 'DetailedPageBannerLeft',
  DetailedPageBannerCenter = 'DetailedPageBannerCenter',
  DetailedPageBannerRight = 'DetailedPageBannerRight',
  LandscapeFourCardsTray = 'LandscapeFourCardsTray',
  LandscapeThreeCardsTray = 'LandscapeThreeCardsTray',
  LandscapeTwoCardsTray = 'LandscapeTwoCardsTray',
  StudiosSmall = 'StudiosSmall',
  StudiosMedium = 'StudiosMedium',
  StudiosLarge = 'StudiosLarge',
}

export type TraySelectorTypeWithLayout = TraySelectorType | CardStyleApiModel | CardShapeApiModel | CardNumbersApiModel;

export interface TraySelectorOption {
  type: TraySelectorTypeWithLayout;
  title: string;
  image: string;
}
